<template>
  <div>
    <iframe :src="iframeUrl" frameborder="0" class="i-frame" allowtransparency></iframe>
  </div>
</template>

<script>
// import axios from 'axios';

export default {
  props: {
    dashboardId: {
      type: Number,
      required: true,
    },
    params: {
      type: Object,
      default: () => ({}),
    },
    title: {
      type: String,
      default: 'Metabase Report',
    },
  },
  data() {
    return {
      iframeUrl: "",
    };
  },
  created() {
    this.generateEmbedUrl();
  },
  methods: {
    async generateEmbedUrl() {
      const METABASE_SITE_URL = "https://meta.zink.com.au";
      
      try {
        const response = await axios.post('/api/v1/metabase-url', {
          dashboard_id: this.dashboardId,
          params: this.params,
        });

        const token = response.data.token;
        this.iframeUrl = `${METABASE_SITE_URL}/embed/dashboard/${token}?date=past1months#theme=transparent&bordered=false&titled=false`;

        console.log("iframeUrl:", this.iframeUrl);
      } catch (error) {
        console.error("Error generating embed URL:", error);
      }
    },
  },
};
</script>

<style scoped>
.i-frame {
  height: 80vh;
  width: 100%;
}
</style>
